import { Injectable } from '@angular/core';
import * as LabelEditActions from '@app/pcs/actions/label-edit';
import { LabelEditActionTypes } from '@app/pcs/actions/label-edit';
import * as ShareFilterLabelActions from '@app/pcs/actions/share-filter-label';
import { PcsEntity, UserLabel } from '@app/pcs/models';
import * as fromPcs from '@app/pcs/reducer';
import { EMPTY_USER_LABEL, getLabelId } from '@app/pcs/util/user-label';
import { ValdrConstraints } from '@app/valdr';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action, select, Store } from '@ngrx/store';
import { hasValue, mapPayload } from '@util';
import { switchMap, withLatestFrom } from 'rxjs/operators';

type InitLabelFormActions = (label: UserLabel, valdrConstraints: ValdrConstraints) => Action[];
const initLabelFormActions: InitLabelFormActions = (userLabel: UserLabel, valdrConstraints: ValdrConstraints): Action[] => [
  new LabelEditActions.CreateLabelForm({userLabel: hasValue(getLabelId(userLabel)) ? userLabel : EMPTY_USER_LABEL,
    valdrConstraints}),
  new LabelEditActions.ToggleEditLabelForm()
];

@Injectable()
export class LabelEditEffects {

  labelFormDisplayed$ = this.store.select(fromPcs.getLabelFormDisplayed);

  displayEditForm$ = createEffect(() => this.actions$.pipe(
    ofType<LabelEditActions.DisplayEditLabelForm>(LabelEditActionTypes.DisplayEditLabelForm),
    mapPayload(),
    withLatestFrom(this.labelFormDisplayed$),
    switchMap(([userLabel, labelFormDisplayed]: [UserLabel, boolean]) =>
      labelFormDisplayed ? [new LabelEditActions.ResetState()] : [new LabelEditActions.InitLabelForm(userLabel)]
    )));

  createLabelEditForm$ = createEffect(() => this.actions$.pipe(
    ofType<LabelEditActions.InitLabelForm>(LabelEditActionTypes.InitLabelForm),
    mapPayload(),
    withLatestFrom(
      this.store.pipe(select(fromPcs.getConstraintsForTypes({ types: [PcsEntity.Label] }))),
      this.store.pipe(select(fromPcs.getDisplayShareForm))
    ),
    switchMap(([label, valdrConstraints, shareFormDisplayed]: [UserLabel, ValdrConstraints, boolean]) =>
      shareFormDisplayed ? [new ShareFilterLabelActions.ToggleShareForm(), ...initLabelFormActions(label, valdrConstraints)]
        : initLabelFormActions(label, valdrConstraints)
    )
  ));

  constructor(private actions$: Actions,
    private store: Store<any>) {
  }

}
